import { StatusBar } from "expo-status-bar";
import React, { useEffect } from "react";
import { StyleSheet, Text, View } from "react-native";

import { Image, Input, Button } from "react-native-elements";

import { auth } from "../firebase";

export default function LoginScreen({ navigation }) {
  const [email, set_email] = React.useState("");
  const [password, set_password] = React.useState("");

  useEffect(() => {
    const unsubscibe = auth.onAuthStateChanged((auth_user) => {
      if (auth_user) {
        navigation.replace("Home");
      }
    });
    return unsubscibe;
  }, []);

  const login = () => {
    auth
      .signInWithEmailAndPassword(email, password)
      .catch((error) => alert(error.message));
  };

  return (
    <View style={styles.container}>
      <StatusBar style="light" />

      <Image
        source={{
          uri:
            "https://blog.mozilla.org/internetcitizen/files/2018/08/signal-logo.png",
        }}
        style={{
          width: 200,
          height: 200,
        }}
      />

      <View style={styles.input_container}>
        <Input
          placeholder="Email"
          type="email"
          autoFocus
          value={email}
          onChangeText={(new_email) => set_email(new_email)}
        />
        <Input
          placeholder="Password"
          type="password"
          secureTextEntry
          value={password}
          onChangeText={(new_password) => set_password(new_password)}
        />
        <View style={styles.buttons}>
          <Button
            title="Login"
            onPress={login}
            buttonStyle={{
              margin: 5,
            }}
          />
          <Button
            title="Register"
            type="outline"
            buttonStyle={{
              margin: 5,
            }}
            onPress={() => navigation.navigate("Register")}
          />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  input_container: {
    width: "90%",
    alignItems: "center",
    justifyContent: "center",
  },
  buttons: {
    width: "70%",
  },
});
